import { render, staticRenderFns } from "./OrdersTopLeft.vue?vue&type=template&id=0614472a&scoped=true&"
import script from "./OrdersTopLeft.vue?vue&type=script&lang=js&"
export * from "./OrdersTopLeft.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTopLeft.vue?vue&type=style&index=0&id=0614472a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614472a",
  null
  
)

export default component.exports